import React, { useState } from 'react';

import { FilterAlertInterFace } from '../../../interface/alerts.interface';
import MyButton from '../../../shared-components/button/Button';
import CustomDateRange from '../../../shared-components/custom-date-range/CustomDateRange';
import CustomInput from '../../../shared-components/custom-input/CustomInput';

/**
 * filter
 * @param param0
 * @returns
 */
function AlterFilter({
  handleCancel,
  oldFilterData,
  handleSubmitFilter,
}: {
  handleCancel: () => void;
  oldFilterData: FilterAlertInterFace;
  handleSubmitFilter: (filterData: FilterAlertInterFace) => void;
}) {
  const [filterDetails, setFilterDetails] = useState<FilterAlertInterFace>(
    oldFilterData || {
      search: '',
      fromDate: '',
      toDate: '',
    },
  );
  /**
   * filter function
   */
  const handleInputChange = (name: string, value: string | number | (string | number)[]) => {
    setFilterDetails((previous) => ({
      ...previous,
      [name]: value,
    }));
  };
  /**
   * apply filter
   */
  const handleSubmit = () => {
    handleSubmitFilter(filterDetails);
  };

  return (
    <div className="reports-filter-container">
      <div className="filter-container">
        <div className="filter-input-field">
          <CustomInput
            name="search"
            inputLabel="Station Name / id"
            type="text"
            placeholder="Enter the name"
            value={filterDetails.search || ''}
            onChangeValue={handleInputChange}
          />
        </div>
        <div className="filter-date-field">
          <CustomDateRange
            name1="fromDate"
            name2="toDate"
            inputLabel="Date"
            value1={filterDetails.fromDate || ''}
            value2={filterDetails.toDate || ''}
            onChangeValue={handleInputChange}
            icon
          />
        </div>
      </div>
      {/* <div className="filter-select-box">
                <div className="form-field">
                    <SelectFiled
                        name="status"
                        inputLabel="Status"
                        placeholder="All"
                        onChangeValue={handleInputChange}
                        options={[
                            {
                                label: 'Process',
                                value: 'process',
                            },
                        ]}
                        selectedValue={filterDetails.status}
                    />
                </div>
            </div> */}
      <div className="filter-buttons">
        <div className="filter-close">
          <MyButton
            label="Cancel"
            buttonType="back"
            onClickFunc={handleCancel}
            disableHoverEffect
          />
        </div>
        <div className="filter-apply">
          <MyButton
            label="Submit"
            buttonType="submit"
            onClickFunc={handleSubmit}
            disableHoverEffect
          />
        </div>
      </div>
    </div>
  );
}

export default AlterFilter;
